// Výpočet denního příjmu na frontendu (15.7.2026) — PŘESNĚ zrcadlí serverový
// spocitejPrijem (netlify/functions/_lib/jidelnicekLib.cjs, metodika FitWay40):
// Mifflin-St Jeor BMR × koeficient aktivity dle životního stylu, hubnutí −15 %
// / nabírání +10 %, makra 25 % bílkoviny / 45 % sacharidy / 30 % tuky.
// Používá se pro krok "Návrh příjmu ke schválení" před generováním
// (PDF jídelníček i jídelníček do aplikace). Při změně serverového výpočtu
// změnit i tady!

export function spocitejPrijemJs(ans) {
  // KLUBOVÁ ÚROVEŇ MÁ KALORIE ZADANÉ, ne dopočítané z váhy a výšky.
  // Zrcadlí stejnou větev v serverovém spocitejPrijem. Pouští se jen pro
  // dotazník s `klub: true`; u klientky se nic nemění.
  if (ans && ans.klub && Number(ans.uroven_kcal)) {
    const kcal = Number(ans.uroven_kcal);
    const na5 = (x) => Math.round(x / 5) * 5;
    const bilkoviny = na5(kcal * 0.064);
    const tuky = na5((kcal * 0.30) / 9);
    return {
      kalorie: kcal, bmr: null, tdee: null, koef: null, cilFaktor: null, klub: true,
      makra: { bilkoviny, tuky, sacharidy: na5((kcal - 4 * bilkoviny - 9 * tuky) / 4) },
    };
  }
  const num = (x) => parseFloat(String(x || "").replace(",", "."));
  const vaha = num(ans.vaha), vyska = num(ans.vyska), vek = num(ans.vek);
  if (!vaha || !vyska || !vek) return null;
  const muz = /muž/i.test(String(ans.pohlavi || ""));
  const bmr = 10 * vaha + 6.25 * vyska - 5 * vek + (muz ? 5 : -161);
  const KOEF = [1.2, 1.4, 1.7, 1.8, 2.0, 2.2];
  const OPT = ["sedavé zaměstnání bez tréninku", "1-2 krát týdně", "3-4 krát týdně",
    "6 krát týdně", "manuálně těžké zaměstnání a 3-4", "velmi těžce pracující"];
  let koef = 1.4;
  const st = String(ans.zivotni_styl || "").toLowerCase();
  for (let i = OPT.length - 1; i >= 0; i--) if (st.includes(OPT[i])) { koef = KOEF[i]; break; }
  const tdee = bmr * koef;
  const cil = String(ans.cil || "");
  const cf = /hubnout/i.test(cil) ? 0.85 : /nabírat|svalovou/i.test(cil) ? 1.10 : 1.0;
  const kalorie = Math.round((tdee * cf) / 50) * 50;
  return {
    kalorie, bmr: Math.round(bmr), tdee: Math.round(tdee), koef, cilFaktor: cf,
    makra: {
      sacharidy: Math.round((kalorie * 0.45) / 4),
      bilkoviny: Math.round((kalorie * 0.25) / 4),
      tuky: Math.round((kalorie * 0.30) / 9),
    },
  };
}

// Příjem → hodnoty formuláře (stringy pro inputy).
export const prijemNaFormular = (p) => p && p.makra
  ? { kalorie: String(p.kalorie || ""), bilkoviny: String(p.makra.bilkoviny || ""), sacharidy: String(p.makra.sacharidy || ""), tuky: String(p.makra.tuky || "") }
  : { kalorie: "", bilkoviny: "", sacharidy: "", tuky: "" };

// Kalorie konzistentní s makry: 4 kcal/g bílkoviny a sacharidy, 9 kcal/g tuky.
export const kcalZMaker = (pr) => {
  const n = (x) => parseInt(pr[x], 10) || 0;
  return Math.round((4 * n("bilkoviny") + 4 * n("sacharidy") + 9 * n("tuky")) / 10) * 10;
};

// Slovní popis úpravy dle cíle (pro info text u návrhu).
export const cilFaktorText = (cil) => /hubnout/i.test(String(cil || "")) ? "hubnutí (příjem snížen o 15 %)"
  : /nabírat|svalovou/i.test(String(cil || "")) ? "nabírání (příjem zvýšen o 10 %)" : "udržení váhy";
